import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { WalletProvider } from '../../providers/wallet/wallet';
import { RouteProvider } from '../../providers/route/route';
declare let window;

@Injectable()
export class QrcodescannerProvider {
  private scanResultCallback: ((data: any) => void) | null = null;
  
  constructor(private platform: Platform, private walletProvider: WalletProvider, private routeProvider: RouteProvider) {
    
  }

  // Get permissions plugin dynamically to avoid timing issues on app restart
  private getPermissionsPlugin() {
    return window.cordova && window.cordova.plugins ? window.cordova.plugins.permissions : null;
  }

  // Called by QR scanner page when scan is complete or cancelled
  onScanResult(data: any) {
    if (this.scanResultCallback) {
      this.scanResultCallback(data);
      this.scanResultCallback = null;
    }
  }

  async initializeAndOpenQRScanner(actionType = "", useDevBarcode = false, canShowLogos=false, canShowToggleButton = true, initialToggleVal = null){
    return new Promise<any>(async (resolve, reject) => {
      const permissions = this.getPermissionsPlugin();
      if(this.platform.is('android') && permissions){
        permissions.checkPermission(permissions.CAMERA, async (status) => {
          if (status.hasPermission) {
            resolve(await this.openQRHelper(actionType, useDevBarcode, canShowLogos, canShowToggleButton, initialToggleVal));
          } else {
            permissions.requestPermission(permissions.CAMERA, async (requestStatus) => {
              if (!requestStatus.hasPermission) {
                this.walletProvider.showQRCameraSettingsError();
                reject(null);
              } else {
                resolve(await this.openQRHelper(actionType, useDevBarcode, canShowLogos, canShowToggleButton, initialToggleVal));
              }
            }, () => {
              this.walletProvider.showQRCameraSettingsError();
              reject(null);
            });
          }
        }, () => {
          permissions.requestPermission(permissions.CAMERA, async (requestStatus) => {
            if (!requestStatus.hasPermission) {
              this.walletProvider.showQRCameraSettingsError();
              reject(null);
            } else {
              resolve(await this.openQRHelper(actionType, useDevBarcode, canShowLogos, canShowToggleButton, initialToggleVal));
            }
          }, () => {
            this.walletProvider.showQRCameraSettingsError();
            reject(null);
          });
        });
      } else{
        resolve(await this.openQRHelper(actionType, useDevBarcode,canShowLogos,canShowToggleButton, initialToggleVal));
      }  
    })
  }

  async openQRHelper(actionType, useDevBarcode, canShowLogos, canShowToggleButton, initialToggleVal = null){
    return new Promise<any>(async (resolve, reject) => {
      try{
        // Set up callback to receive scan result from QR scanner page
        this.scanResultCallback = (barcodeData) => {
          if (barcodeData) {
            resolve(barcodeData);
          } else {
            // User closed without scanning, reject to ensure promise settles without triggering error modals
            reject(null);
          }
        };

        // Use push navigation instead of modal for Android camera-preview compatibility
        this.routeProvider.push(
          this.routeProvider.pages.QrScannerHelperPage, 
          {
            canShowLogos: canShowLogos, 
            actionType: actionType, 
            useDevBarcode: useDevBarcode, 
            canShowToggleButton: canShowToggleButton,
            initialToggleVal: initialToggleVal
          }
        );
      } catch (ex) {
        reject(null)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/qrcodescanner/qrcodescanner.ts